module.exports = "<p class=\"marquee-text\" [ngClass]=\"{marquee: shouldMarquee}\"><span #marqueeText><ng-content></ng-content></span></p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pillar/common/components/marquee-text-box.component.html
// module id = ./src/app/pillar/common/components/marquee-text-box.component.html
// module chunks = main